import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className="footer">
        <div className="container">
        <h1><span>Karl</span>-Kani</h1>
            <p>&copy; Copyright 2022</p>
        </div>
    </div>
  )
}

export default Footer